// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__6F70B","label":"LabeledBox_label__3SNj0"};